import { Link } from "react-router-dom";

const Error = () => {
  return (
    <div className="error-section">
      <div className="error-title">
        <h1>404</h1>
      </div>
      <div className="error-content">
        <p>The page you are looking for is not available.</p>
        <Link to="/">
          <button className="error-buttton">Go to Home</button>
        </Link>
      </div>
    </div>
  );
};

export default Error;
